/**
 * Lightbox.
 *
 * Features:
 * - Detect clicks on `TRIGGER_SELECTOR` (`.popup-anchor`) and open target element specified in `href` attribute.
 * 
 * Notes:
 * - This is using Bootstrap Modal. But we should avoid using Bootstrap way to setup the modal for consistency.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  let initialized = false;
  let BootstrapModal = null;

  const TRIGGER_SELECTOR = '.popup-anchor';
  const TRIGGER_TARGET_DATA_KEY = 'lightbox-target-id';
  const TRIGGER_MODAL_DATA_KEY = 'lightbox-target-modal';
  const TRIGGER_TARGET_DATA_ATTRIBUTE = 'data-modal-target';
  const STATIC_MODAL_CLASS = '-modal';
  const ON_LOAD_OPEN_POPUP_BY_HASH = false;

  const DEFAULT_MODAL_OPTIONS = {
    backdrop: true,
    keyboard: true,
    focus: true
  };
  
  /**
   * Initialize events
   */
  const initEvents = () => {
    $(window.document).on('click.lightBox', TRIGGER_SELECTOR, (ev) => {
      const popupId = openPopupFrom($(ev.currentTarget));
      if (popupId) {
        window.location = `#${popupId}`;
        ev.preventDefault();
      }
    });

    // Try to focus first input element on the popup after is has been shown.
    window.document.addEventListener('shown.bs.modal', (ev) => {
      if (ev.target) {
        try {
          const inp = $('form', ev.target).not(':hidden').find(':input').not(':hidden, :disabled, [readonly]');
          if (inp.length) {
            inp.get(0).focus();
          }
        }
        catch (err) {
          //
        }
      }
    });

    if (ON_LOAD_OPEN_POPUP_BY_HASH) {
      maybeOpenPopupHash();
    }
  };

  /**
   * Check current URL hash, if it refers to a popup, open it.
   * 
   * @returns {string} ID of the popup
   */
  const maybeOpenPopupHash = () => {
    if (window.location.hash) {
      const elPopup = getPopupTargetFromUrl(window.location.hash);

      if (!elPopup.length) {
        return false;
      }

      if (!elPopup.is('.modal')) {
        return false;
      }

      return showPopupForm(elPopup);
    }
  };

  /**
   * Get popup element from a specific element.
   * 
   * @param {HTMLElement} el 
   * @returns {HTMLElement}
   */
  const getPopupTargetFromElement = (el) => {
    let tmp;
    
    // get ID selector from href
    tmp = el.prop('href') || '';
    if (tmp) {
      return getPopupTargetFromUrl(tmp);
    }
    // try to get from `TRIGGER_TARGET_DATA_ATTRIBUTE` attribute
    else if ((tmp = el.attr(TRIGGER_TARGET_DATA_ATTRIBUTE))) {
      return getPopupTargetFromUrl(tmp);
    }

    return false;
  };

  /**
   * Get popup element from URL string.
   * 
   * @param {String} url 
   * @returns {HTMLElement}
   */
  const getPopupTargetFromUrl = (url) => {
    let target;
    let arr;
    
    if (url) {
      arr = url.split('#');
      if (arr.length > 1 && arr[arr.length-1] !== '') {
        target = `#${arr[arr.length-1]}`;
        target = $(target);
      }
    }

    if (!target || !target.length) {
      return false;
    }

    // use first one on multiple match
    return target.first();
  };

  /**
   * Get modal options from popup element.
   * 
   * @param {HTMLElement} el 
   * @returns {Object}
   */
  const getModalOptions = (el) => {
    const options = DEFAULT_MODAL_OPTIONS;

    if (el.hasClass(STATIC_MODAL_CLASS)) {
      options.backdrop = 'static';
      options.keyboard = false;
    }

    return options;
  };

  /**
   * Open popup from a specific element.
   * 
   * @param {HTMLElement} el 
   * @returns {String} Popup element ID
   */
  const openPopupFrom = (el) => {
    const elPopup = getPopupTargetFromElement(el);

    if (!elPopup.length) {
      return false;
    }

    return showPopupForm(elPopup);
  };

  /**
   * Show popup.
   * 
   * @param {HTMLElement} elPopup 
   * @param {HTMLElement} elTrigger 
   * @returns {String} Popup element ID
   */
  const showPopupForm = (elPopup, elTrigger) => {
    const elPopupId = elPopup.attr('id');
    let modal;

    if (elTrigger) {
      if (elTrigger.data(TRIGGER_TARGET_DATA_KEY) !== elPopupId) {
        elTrigger.data(TRIGGER_TARGET_DATA_KEY, elPopupId);
        elTrigger.removeData(TRIGGER_MODAL_DATA_KEY);
      }

      modal = elTrigger.data(TRIGGER_MODAL_DATA_KEY);
    }
      
    if (!modal) {
      const modalOptions = getModalOptions(elPopup);
      modal = new BootstrapModal(elPopup, modalOptions);

      if (elTrigger) {
        elTrigger.data(TRIGGER_MODAL_DATA_KEY, modal);
      }
    }

    modal.show();
    return elPopupId;
  };
  
  // Public interface and default initializer
  const api = () => {
    if (initialized) {
      return;
    }

    initialized = true;

    import(/* webpackPreload: true */ 'bootstrap/js/dist/modal').then(({default: _}) => {
      BootstrapModal = _;
      initEvents();
    });
  };

  api.openPopupFrom = openPopupFrom;
  
  return api;
})(jQuery, window);